import React, { useState } from 'react'
import type { Breadcrumb, ChildContainerProps, LayoutConfig, LayoutContextProps, LayoutState } from '../../../types/types'

export const LayoutContext = React.createContext({} as LayoutContextProps)

export const LayoutProvider = (props: ChildContainerProps) => {
    const [breadcrumbs, setBreadcrumbs] = useState<Breadcrumb[]>([])
    const [layoutConfig, setLayoutConfig] = useState<LayoutConfig>({
        ripple: false,
        inputStyle: 'outlined',
        menuMode: 'static',
        menuTheme: 'colorScheme',
        colorScheme: 'light',
        theme: 'indigo',
        scale: 12,
    })

    const [layoutState, setLayoutState] = useState<LayoutState>({
        staticMenuDesktopInactive: false,
        overlayMenuActive: false,
        overlaySubmenuActive: false,
        profileSidebarVisible: false,
        configSidebarVisible: false,
        staticMenuMobileActive: false,
        menuHoverActive: false,
        resetMenu: false,
        sidebarActive: false,
        anchored: false,
    })

    const onMenuToggle = () => {
        if (isOverlay()) {
            setLayoutState((prevLayoutState: LayoutState) => ({
                ...prevLayoutState,
                overlayMenuActive: !prevLayoutState.overlayMenuActive,
            }))
        }

        if (isDesktop()) {
            setLayoutState((prevLayoutState: LayoutState) => ({
                ...prevLayoutState,
                staticMenuDesktopInactive: !prevLayoutState.staticMenuDesktopInactive,
            }))
        } else {
            setLayoutState((prevLayoutState: LayoutState) => ({
                ...prevLayoutState,
                staticMenuMobileActive: !prevLayoutState.staticMenuMobileActive,
            }))
        }
    }

    const showConfigSidebar = () => {
        setLayoutState((prevLayoutState: LayoutState) => ({
            ...prevLayoutState,
            configSidebarVisible: true,
        }))
    }

    const showProfileSidebar = () => {
        setLayoutState((prevLayoutState: LayoutState) => ({
            ...prevLayoutState,
            profileSidebarVisible: !prevLayoutState.profileSidebarVisible,
        }))
    }

    const isOverlay = () => {
        return layoutConfig.menuMode === 'overlay'
    }

    const isSlim = () => {
        return layoutConfig.menuMode === 'slim'
    }

    const isSlimPlus = () => {
        return layoutConfig.menuMode === 'slim-plus'
    }

    const isHorizontal = () => {
        return layoutConfig.menuMode === 'horizontal'
    }

    const isDesktop = () => {
        return window.innerWidth > 991
    }

    const value = {
        layoutConfig,
        setLayoutConfig,
        layoutState,
        setLayoutState,
        onMenuToggle,
        showConfigSidebar,
        showProfileSidebar,
        isSlim,
        isSlimPlus,
        isHorizontal,
        isDesktop,
        breadcrumbs,
        setBreadcrumbs,
    }

    return (
        <LayoutContext.Provider value={value}>
            <>
                <header>
                    <title>olive-jp DMS</title>
                    <meta charSet="UTF-8" />
                    <meta name="description" content="olive-jp DMS" />
                    <meta name="robots" content="index, follow" />
                    <meta name="viewport" content="initial-scale=1, width=device-width" />
                    <meta property="og:type" content="website"></meta>
                    <meta property="og:title" content="olive-jp DMS"></meta>
                    <meta property="og:url" content=""></meta>
                    <meta property="og:description" content="olive-jp DMS" />
                    <meta property="og:image" content=""></meta>
                    <meta property="og:ttl" content="604800"></meta>
                    <link rel="icon" href={`/STL_Favicon-01.png`} type="image/x-icon"></link>
                </header>
                {props.children}
            </>
        </LayoutContext.Provider>
    )
}
